import {connect} from 'react-redux';
import Conversation, {ConversationProps} from './Conversation';
import Action from '../../redux/Actions';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';

const mapStateToProps = (state: ReduxState, ownProps: ConversationContainerProps): Partial<ConversationProps> => {
   return {
      visibleComments: state.topLevelComments || [],
      allComments: state.comments || [],
      showCommentTime: ownProps.showCommentTime,
      reviewId: ownProps.reviewId,
      hideResolved: state.hideResolved || false,
      searchText: state.searchText || '',
      themeName: state.themeName,
      hideEmptyState: ownProps.hideEmptyState,
      annotationMode: state.annotationMode,
      mobileViewingMode: state.mobileViewingMode
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<ConversationProps> => {
   return {
      setCommentSearchText: searchText => {
         dispatch(Action.setCommentSearchText(searchText));
      },
      setCommentFilter: filter => {
         dispatch(Action.setCommentFilter(filter));
      },
      setAnnotationMode: annotationMode => {
         dispatch(Action.setAnnotationMode(annotationMode));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversation);

interface ConversationContainerProps {
   showCommentTime: boolean;
   reviewId: string;
   hideEmptyState: boolean;
}
